/* ===========================================================================
   Shady Co — cart
   ---------------------------------------------------------------------------
   AJAX add / change against Shopify's Cart API, with the drawer re-rendered
   through the Section Rendering API so the markup always comes from Liquid and
   never has to be duplicated in JavaScript.

   Routes come from window.theme (set in layout/theme.liquid) rather than being
   hard-coded, so this keeps working under Markets URL prefixes such as /en-za.
   =========================================================================== */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  function drawer() { return document.getElementById('cart-drawer'); }

  function openDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('hidden');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    window.requestAnimationFrame(function () {
      var overlay = el.querySelector('[data-cart-overlay]');
      var panel = el.querySelector('[data-cart-panel]');
      if (overlay) overlay.classList.remove('opacity-0');
      if (panel) panel.classList.remove('translate-x-full');
    });
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    var overlay = el.querySelector('[data-cart-overlay]');
    var panel = el.querySelector('[data-cart-panel]');
    if (overlay) overlay.classList.add('opacity-0');
    if (panel) panel.classList.add('translate-x-full');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.setTimeout(function () { el.classList.add('hidden'); }, 500);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  /**
   * Re-render the drawer from Liquid. `?sections=cart-drawer` returns the
   * section's HTML as JSON — the same mechanism Dawn uses.
   */
  function refreshDrawer() {
    return fetch((routes.cart || '/cart') + '?sections=cart-drawer', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('cart-drawer');
        var current = drawer();
        if (!fresh || !current) return;

        var wasOpen = !current.classList.contains('hidden');
        current.innerHTML = fresh.innerHTML;

        if (wasOpen) {
          var overlay = current.querySelector('[data-cart-overlay]');
          var panel = current.querySelector('[data-cart-panel]');
          if (overlay) overlay.classList.remove('opacity-0');
          if (panel) panel.classList.remove('translate-x-full');
        }
      });
  }

  function setError(form, message) {
    var target = form && form.querySelector('[data-cart-error]');
    if (!target) return;
    target.textContent = message || '';
    target.classList.toggle('hidden', !message);
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = strings.adding || 'Adding…';
    }
    setError(form, '');

    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString(),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || strings.cartError);
          return data;
        });
      })
      .then(function () { return fetch(routes.cart ? routes.cart + '.js' : '/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        return refreshDrawer().then(openDrawer);
      })
      .catch(function (error) { setError(form, error.message || strings.cartError); })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      });
  }

  function changeQuantity(key, quantity) {
    return fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        return refreshDrawer();
      });
  }

  /* Event delegation — survives every drawer re-render without rebinding. */
  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-cart-open]');
    if (open && drawer() && window.theme && window.theme.routes) {
      // Only intercept when the drawer exists; otherwise let the link through.
      event.preventDefault();
      refreshDrawer().then(openDrawer);
      return;
    }

    if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
      closeDrawer();
      return;
    }

    var quantityButton = event.target.closest('[data-cart-quantity]');
    if (quantityButton) {
      event.preventDefault();
      changeQuantity(quantityButton.dataset.key, parseInt(quantityButton.dataset.cartQuantity, 10));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  window.ShadyCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
})();
